import axios from "~/plugins/axios";

export default {
  getById(automationId, includes = [
    "search",
    "automation_action",
    "extending_searches",
    "email_user",
    "email_account",
    "email_template",
    "html_email_template",
  ]) {
    return axios
      .get(`/web_api/v1/global_automation/${automationId}`, {
        params: {
          includes,
        },
      })
      .then((response) => response.data);
  },
  paginateWhereWithoutGlobalAutomationConfiguration(
    page = 1,
    perPage = 15,
    filter = null,
    includes = [
      "global_search",
      "global_template",
      "automation_action",
      "global_extending_searches",
      "search_thumbnail",
      "global_automation_configurations",
    ],
  ) {
    return axios.get("/web_api/v1/global_automation/without_configuration", {
      params: {
        ...filter,
        page,
        perPage,
        includes,
      },
    }).then((response) => response.data);
  },
  paginateWhereHasGlobalAutomationConfiguration(
    page = 1,
    perPage = 15,
    filter = null,
    includes = [
      "global_search",
      "global_template",
      "automation_action",
      "global_extending_searches",
      "search_thumbnail",
      "global_automation_configurations",
    ],
  ) {
    return axios.get("/web_api/v1/global_automation/with_configuration", {
      params: {
        ...filter,
        page,
        perPage,
        includes,
      },
    }).then((response) => response.data);
  },
  paginate(
    page = 1,
    perPage = 15,
    includes = [
      "global_search",
      "global_template",
      "automation_action",
      "global_extending_searches",
      "search_thumbnail",
      "global_automation_configurations",
    ],
  ) {
    return axios.get("/web_api/v1/global_automation", {
      params: {
        page,
        perPage,
        includes,
      },
    }).then((response) => response.data);
  },
  paginateActive(
    page = 1,
    perPage = 15,
    filter = null,
    includes = [
      "global_search",
      "global_template",
      "automation_action",
      "global_extending_searches",
      "global_automation_configurations",
      "search_thumbnail",
    ],
  ) {
    return axios.get("/web_api/v1/global_automation/active", {
      params: {
        page,
        perPage,
        filter,
        includes,
      },
    })
      .then((response) => response.data);
  },
  searchDescriptionByGlobalAutomation(globalAutomationId) {
    return axios.get(`/web_api/v1/global_automation/${globalAutomationId}/search_descriptions`)
      .then((response) => response.data.data);
  },
  paginateSearchablesByGlobalAutomation(
    globalAutomationId,
    page,
    perPage,
    name,
    include = [
      "customer",
    ],
  ) {
    return axios
      .get(`/web_api/v1/global_automation/${globalAutomationId}/searchables`, {
        params: {
          page,
          perPage,
          include,
        },
      })
      .then((response) => response.data);
  },
};
